import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestAccess } from 'project/ducks/ndas';
import { toggleRightDrawer } from 'header/ducks';
import { toggleParticipateForm } from 'project/ducks/form';
import { getProject } from 'project/ducks/project';
import {
  canRequestProjectAccess, getParticipationForbiddenReason, canWatch, showPromoContent
} from 'project/utils';
import { withRouter } from 'react-router';
import last from 'lodash/last';
import HeaderButtons from 'project/components/header_buttons';

const mapStateToProps = (state, { routes }) => {
  const lastRoute = last(routes);
  const user = state.user.profile_data;
  const project = getProject(state);

  return {
    showFilters: lastRoute.name === 'entries' || lastRoute.name === 'your-entries',
    canRequestAccess: canRequestProjectAccess(state),
    canParticipate: !getParticipationForbiddenReason(state),
    canWatch: canWatch(state),
    showPromoContent: showPromoContent({ user, project, routes })
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    toggleRightDrawer,
    toggleParticipateForm,
    requestAccess
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderButtons));
